<template>
  <div>
    <div class="d-flex flex-row justify-content-between">
      <span class="h4">Selected Users</span>

      <div>
        <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
          <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
            :class="{ 'change-background': button.status }" @click="handleButtonClick(index, 'selectIndexNonExcel', 'buttons')" type="button">
            {{ button.name }}
          </button>
        </div>
      </div>
    </div>

    <div>
      <NormalData :massNotificationId="massNotificationId" v-if="selectedIndex == 0" />
      <existing :massNotificationId="massNotificationId" v-if="selectedIndex == 1"/>
      <generalData :table_id="'non-existing-table'" :arrayData="mainData.non_existing_users" v-if="selectedIndex == 2"/>
      <generalData :tableHeader="['account_number', 'name', 'ic_number', 'mobile_number']" :table_id="'newly-register-table'" :arrayData="mainData.newly_registers" v-if="selectedIndex == 3"/>
      <purchasesData :table_id="'notification-purchases-table'" :arrayData="mainData.purchases" v-if="selectedIndex == 4"/>
      <purchasesData :table_id="'notification-redeem-table'" :arrayData="mainData.redeems" v-if="selectedIndex == 5"/>
    </div>
  </div>
</template>

<script>
import NormalData from './data.vue';
import generalData from './../users/general-data.vue';
import purchasesData from './../users/purchases-data.vue';
import existing from './existing.vue';

export default {
  components: { NormalData, generalData, purchasesData, existing },

  props: {
    buttons: {
      type: Array,
      required: true
    },
    handleButtonClick: {
      type: Function,
      required: true,
    },

    mainData: {
      type: Object,
      default: {}
    },

    selectedIndex: {
      type: Number,
      default: 0
    },

    massNotificationId: {
      type: [Number, String]
    }
  },
  
  data() {
    return {
      
    }
  },

  methods: {

  },


  mounted() {
  }
}

</script>


<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
